<template>
  <div class="w-100">

    <template v-for="guest in guestTypes">
      <div class="py-3 border-bottom d-flex" v-if="guest.show">
        <div class="flex-fill">
          <p class="mb-0 body-1-4">{{ guest.title }}</p>
          <p class="mb-0 body-3">{{ guest.description }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between" style="width: 100px;">
          <img 
            v-if="guest.count > guest.min" 
            src="../../../assets/img/icon/minus-black.png"
            class="cursor-pointer border rounded-100 p-2" width="30"
            @click="updateGuest(guest, -1)">
          <img 
            v-else 
            src="../../../assets/img/icon/decrement.png"
            class="cursor-disable border rounded-100 p-2" width="30">

          <p class="mb-0 font-lato text-16">{{ guest.count }}</p>
          <img 
            src="../../../assets/img/icon/plus-black.png"
            class="cursor-pointer border rounded-100 p-2" width="30"
            @click="updateGuest(guest, 1)">
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    props:{
      defaultData: {
        type: Object,
        default: () => {}
      }
    },
    data(){
      return{
        guestTypes: [
          { id: 'adult', title: 'Adult', count: 1, min: 1, show: true },
          { id: 'child', title: 'Children', count: 0, min: 0, show: false },
          { id: 'infant', title: 'Infant', count: 0, min: 0, show: false },
        ]
      }
    },
    computed:{
      ...mapGetters(['getMerchant'])
    },
    mounted(){
      this.fillData();
    },
    methods:{
      fillData(){
        this.setConfig();

        if(this.$isEmpty(this.defaultData)) return;

        for(const key in this.defaultData){
          const guestTypesIndex = this.guestTypes.findIndex(guest => guest.id === key);
          if(guestTypesIndex != -1) this.guestTypes[guestTypesIndex].count = this.defaultData[key];
        }
      },
      setConfig() {
        const m = this.getMerchant;

        const configMap = {
          adult: [m.adult_description, true],
          child: [m.children_description, m.search_room_is_show_filter_pax_child],
          infant: [m.infant_description, m.search_room_is_show_filter_pax_infant],
        };

        this.guestTypes = this.guestTypes.map(g => ({
          ...g,
          description: configMap[g.id][0],
          show: configMap[g.id][1]
        }));
      },
      updateGuest(guest, delta) {
        const newCount = guest.count + delta;
        if (newCount >= guest.min) {
          guest.count = newCount;
          this.emitChange();
        }
      },
      emitChange(){
        const updatedGuests = this.guestTypes.reduce((acc, guest) => {
          acc[guest.id] = guest.count;
          return acc;
        }, {});
        this.$emit('guest-change', updatedGuests);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/GuestSelection.vue